import Completer from '../services/Completer';
import Vue from 'vue';
import { Snack, SnackConfig } from '../../types';

const toSnack = (obj?: string | Snack): Snack => {
  return typeof obj === 'string' ? { text: obj } : obj || { text: '' };
};

let $uid = 0;

export class SnackController {
  // Shows a snack-bar item on screen
  async show(text: string | Snack): Promise<void> {
    $uid += 1;
    const uid = $uid;
    const completer = new Completer<void>();
    const remove = () => completer.resolve();

    let snack: SnackConfig;
    if (typeof text === 'string') {
      snack = { uid, text, remove };
    } else {
      snack = { ...text, uid, remove };
    }

    this.add(snack);

    const result = await completer.promise;

    this.remove(snack);

    return result;
  }

  info(text: string | Snack): Promise<void> {
    const snack = { ...toSnack(text), color: 'info' };
    return this.show(snack);
  }

  success(text: string | Snack): Promise<void> {
    const snack = { ...toSnack(text), color: 'success' };
    return this.show(snack);
  }

  warning(text: string | Snack): Promise<void> {
    const snack = { ...toSnack(text), color: 'warning' };
    return this.show(snack);
  }

  error(text: string | Snack): Promise<void> {
    const snack = { ...toSnack(text), color: 'error' };
    return this.show(snack);
  }

  get hasSnacks(): boolean {
    return this.store.snacks.length > 0;
  }

  get topSnack(): SnackConfig | undefined {
    const { snacks } = this.store;
    return snacks[snacks.length - 1];
  }

  private store = Vue.observable({ snacks: Array<SnackConfig>() });

  private add(snack: SnackConfig) {
    this.store.snacks.push(snack);
  }

  private remove(snack: SnackConfig) {
    this.store.snacks = this.store.snacks.filter(p => p !== snack);
  }
}

const snack = new SnackController();

export default snack;
